module.exports = __webpack_public_path__ + "static/flipp-logo-b20d651741c7171fd792f0ef81231727.png";